import { FEATURE_APP_ID } from '@client-hub/shared/constants/feature-hub'
import MfeLoader from '@client-hub/shared/react/components/MfeLoader'

const Product = () => <MfeLoader port={process.env.NX_PROD_CONFIG_MFE_PORT!} mfeId={FEATURE_APP_ID.PROD_CONFIG_MFE} />

export default Product
